import React from 'react'
import { LoungeLobbyScreen } from '@/screens/lounges/LoungeLobbyScreen'

export default function LoungeLobbyRoute() {
  return <LoungeLobbyScreen />
}
